module.exports = BootstrapVue, {BootstrapVueIcons};